'use strict';

exports.__esModule = true;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.clientMiddleware = clientMiddleware;
exports.loggerDev = loggerDev;
exports.logger = logger;
exports.crashReporter = crashReporter;
exports.crashReporterLog = crashReporterLog;

var _config = require('./../../config');

var _config2 = _interopRequireDefault(_config);

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clientMiddleware(client) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;

    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState);
        }

        var promise = action.promise,
            types = action.types,
            rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'types']); // eslint-disable-line no-redeclare

        if (!promise) {
          return next(action);
        }

        var REQUEST = types[0],
            SUCCESS = types[1],
            FAILURE = types[2];

        next((0, _extends3.default)({}, rest, { type: REQUEST }));

        var actionPromise = promise(client);
        actionPromise.then(function (result) {
          next((0, _extends3.default)({}, rest, { result: result, type: SUCCESS }));
        }, function (error) {
          var errObj = (0, _extends3.default)({}, rest, { error: error });
          console.log(errObj);
          if (errObj.error.status === 401) {
            var cookieName = _config2.default.env_bf === 'prod' ? 'expiry_time' : _config2.default.env_bf + '_expiry_time';
            var cookiePath = '/';
            var cookieDomain = _config2.default.cookieDomain;

            _reactCookie2.default.remove(cookieName, { path: cookiePath, domain: cookieDomain });

            if (_config2.default.local) {
              if (!window.location.hash.includes('unsubscription')) {
                var sourceUrl = encodeURIComponent(window.location.href.replace('login', ''));
                window.location.href = 'https://' + window.env.loginHost + '?source=' + sourceUrl;
              }
            } else {
              location.reload();
            }
          }
          // alert('There was an error with the server. Please contact us at support@binaryfountain.com or 1-844-225-8155');
          next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        }).catch(function (error) {
          console.error('MIDDLEWARE ERROR:', error);
          next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        });

        return actionPromise;
      };
    };
  };
}

function loggerDev() {
  return function (_ref2) {
    var getState = _ref2.getState;

    return function (next) {
      return function (action) {
        console.log('dispatching', action);
        var result = next(action);
        console.log('next state', getState());
        return result;
      };
    };
  };
}

function logger() {
  return function (_ref3) {
    var getState = _ref3.getState;

    return function (next) {
      return function (action) {
        var result = next(action);
        window.__data = getState();
        return result;
      };
    };
  };
}

function crashReporter() {
  return function (_ref4) {
    var getState = _ref4.getState;

    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          console.error('Caught an exception!', err, ' with action: ', action, ' and state: ', getState());
          throw err;
        }
      };
    };
  };
}

function crashReporterLog() {
  return function (_ref5) {
    var getState = _ref5.getState;

    return function (next) {
      return function (action) {
        try {
          return next(action);
        } catch (err) {
          // should use this for dev env only ?
          console.error('Caught an exception!', err, ' with action: ', action, ' and state: ', getState());
          var data = new FormData();
          data.append('json', (0, _stringify2.default)({
            url: window.location.href,
            error: err,
            action: action,
            state: getState()
          }));
          fetch('/api/loadLog', {
            method: 'POST',
            redirect: 'follow',
            body: data,
            headers: new Headers({
              'Content-Type': 'text/plain'
            })
          }).then(function () {});

          throw err;
        }
      };
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/clientMiddleware.js
// module id = 1418
// module chunks = 0